import type {
  OrganizationCustomAuthProvider,
  PaginatedOrganizationCustomAuthProviderList
} from 'src/api/main'
import { normalizeListResults } from 'src/utils'

/**
 * The custom-auth-providers list endpoint is annotated as paginated in the
 * generated schema (`{ results: [...] }`), but the backend has pagination
 * disabled and returns a bare array. Without normalising, `response.results`
 * is `undefined` and the table renders its empty state even when the API
 * returned providers (e.g. right after creating one). Accept either shape.
 */
export const selectCustomProviders = (
  response:
    | PaginatedOrganizationCustomAuthProviderList
    | OrganizationCustomAuthProvider[]
): OrganizationCustomAuthProvider[] => normalizeListResults(response)
